import api from './api';

export const getFinancialReports = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/reports/financial?${queryParams}`);
  return response.data;
};

export const exportReport = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/reports/export?${queryParams}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const getDashboardStats = async () => {
  const response = await api.get('/reports/dashboard');
  return response.data;
};
